import _ from "lodash";
import auth from "./auth";
import i18n from "@/localization/localization";
import store from "./store/index";
import { checkAccess, scope } from "@/help/accessData";
import { formatDecimalStatic } from "@/help/decimalStatic";
import { io } from "socket.io-client";
import { useToast } from "vue-toastification";
const $t = (key, params) => i18n.global.t(key, params);
const toast = useToast();
const isNotRwa = checkAccess(scope.notRwa);
let socket = null;
if (process.env.VUE_APP_WEBSOCKET_ENABLED == "true") {
    socket = io(process.env.VUE_APP_WEBSOCKET_HOST, {});
    // Проверка состояний
    socket.on("connect", () => {
        store.commit("socket/setSocket", socket);
        store.commit("socket/setSocketStatus", socket?.connected);
    });
    socket.on("disconnect", () => {
        store.commit("socket/setSocket", null);
        store.commit("socket/setSocketStatus", false);
    });
    socket.on("connect_error", () => {
        store.commit("socket/setSocket", null);
        store.commit("socket/setSocketStatus", false);
    });
    const MessageType = {
        entityChanged: "entityChanged"
    };
    const EntityType = {
        user: "user",
        au_capital: "au_capital",
        test: "test"
    };
    // Получение данных от сервера.
    socket.on(MessageType.entityChanged, async (data) => {
        const defaultTokenId = store.getters["defaultToken/defaultTokenId"];
        switch (data.entityType) {
            case EntityType.test: {
                await notifyAboutTransactions();
                break;
            }
            case EntityType.user: {
                auth.user();
                if (auth?.check() && auth.user()?.id == data.entityId) {
                    const isBalanceUpdate = await notifyAboutTransactions();
                    if (isBalanceUpdate) {
                        store.dispatch("profile/getProfileWihtoutLoading", data.entityId);
                        store.commit("profile/setCheckProfile", Date.now());
                        if (defaultTokenId) {
                            store.dispatch("getBalances", defaultTokenId);
                            store.dispatch("getDailyStats");
                            store.dispatch("getEthAddresses");
                        }
                        if (!isNotRwa) {
                            await store.dispatch("getInvestments");
                        }
                    }
                    else {
                        store.commit("capitals/setUpdateInfoFlag", store.getters["capitals/updateInfoFlag"] + 1);
                        store.dispatch("getDailyStats");
                    }
                }
                break;
            }
            case EntityType.au_capital: {
                store.dispatch("capitals/getAuCapitals", data.entityId);
                store.commit("capitals/setUpdateInfoFlag", store.getters["capitals/updateInfoFlag"] + 1);
                break;
            }
        }
    });
}
else {
    console.warn("VUE_APP_WEBSOCKET_HOST not set, web-sockets disabled");
    store.commit("socket/setSocketStatus", false);
}
const notifyAboutTransactions = async () => {
    const ethAddresses = store.getters["ethAddresses"];
    const ethAddress = ethAddresses[0];
    const beforeTransactions = _.orderBy(store.getters["transactions"], ["id"], ["desc"]); // сменить порядок сортировки
    await store.dispatch("getTransactions", auth?.user()?.id);
    const afterTransactions = store.getters["transactions"];
    const beforeIds = new Set(beforeTransactions.map((transaction) => transaction?.id));
    const newTransactions = afterTransactions.filter((transaction) => !beforeIds.has(transaction?.id));
    let isBalanceUpdate = true;
    for (const transaction of newTransactions) {
        let mnemonic = "";
        let amount = transaction?.amount;
        const token = transaction?.auToken;
        if (token) {
            const decimals = token?.decimals;
            const indent = token?.indent;
            mnemonic = token?.mnemonicEng;
            amount = formatDecimalStatic({
                value: amount,
                decimal: decimals,
                indent
            });
        }
        const capital = transaction?.auCapital;
        const name = capital?.nameEng;
        if (!isNotRwa) { // для RWA
            switch (transaction.methodName) {
                case "deposit":
                    console.info($t("socket.deposit", { amount, mnemonic }));
                    break;
                case "vote":
                    if (!name) {
                        console.info($t("socket.vote", { amount, mnemonic }));
                    }
                    else {
                        console.info($t("socket.vote", { amount, mnemonic, name }));
                    }
                    break;
                case "investing":
                    isBalanceUpdate = false;
                    if (!name) {
                        console.info($t("socket.investing", { amount, mnemonic }));
                    }
                    else {
                        console.info($t("socket.investing", { amount, mnemonic, name }));
                    }
                    break;
                case "hold for withdrawal":
                    console.info($t("socket.withdrawal", { amount, mnemonic }));
                    break;
                case "transfer":
                    if (!token) {
                        console.info($t("socket.transfer", { amount, mnemonic }));
                    }
                    else if (transaction?.addressTo.toUpperCase() == ethAddress?.value.toUpperCase()) {
                        console.info($t("socket.transferTo", { amount, mnemonic }));
                    }
                    else if (transaction?.addressFrom.toUpperCase() ==
                        ethAddress?.value.toUpperCase()) {
                        console.info($t("socket.transferFrom", { amount, mnemonic }));
                    }
                    else {
                        console.info($t("socket.transfer", { amount, mnemonic }));
                    }
                    break;
                case "capital_refund":
                    isBalanceUpdate = false;
                    console.info($t("socket.refund", { amount, mnemonic, name }));
                    break;
                case "investments_release":
                    console.info($t("socket.release", { amount, mnemonic, name }));
                    break;
                case "Transfer to the exchange":
                    console.info($t("socket.toExchange", { amount, mnemonic }));
                    break;
                case "Transfer from the exchange":
                    console.info($t("socket.fromExchange", { amount, mnemonic }));
                    break;
                case "referrals":
                    console.info($t("socket.referrals", { amount, mnemonic }));
                    break;
                case "Payment for open sale tokens":
                    console.info($t("socket.decreased", { amount, mnemonic }));
                    break;
                case "Transfer of open sale tokens":
                    console.info($t("socket.transferOpenSale", { amount: amount, name: transaction?.auToken?.nameEng }));
                    store.commit("capitals/setUpdateInfoFlag", store.getters["capitals/updateInfoFlag"] + 1);
                    break;
                default:
                    console.info($t("socket.balanceChange", { amount, mnemonic }));
                    break;
            }
        }
        else {
            switch (transaction.methodName) {
                case "deposit":
                    toast.info($t("socket.deposit", { amount, mnemonic }));
                    break;
                case "vote":
                    if (!name) {
                        console.info($t("socket.vote", { amount, mnemonic }));
                    }
                    else {
                        toast.info($t("socket.vote", { amount, mnemonic, name }));
                    }
                    break;
                case "investing":
                    isBalanceUpdate = false;
                    if (!name) {
                        console.info($t("socket.investing", { amount, mnemonic }));
                    }
                    else {
                        toast.info($t("socket.investing", { amount, mnemonic, name }));
                    }
                    break;
                case "hold for withdrawal":
                    toast.info($t("socket.withdrawal", { amount, mnemonic }));
                    break;
                case "transfer":
                    if (!token) {
                        console.info($t("socket.transfer", { amount, mnemonic }));
                    }
                    else if (transaction?.addressTo.toUpperCase() == ethAddress?.value.toUpperCase()) {
                        toast.info($t("socket.transferTo", { amount, mnemonic }));
                    }
                    else if (transaction?.addressFrom.toUpperCase() ==
                        ethAddress?.value.toUpperCase()) {
                        toast.info($t("socket.transferFrom", { amount, mnemonic }));
                    }
                    else {
                        toast.info($t("socket.transfer", { amount, mnemonic }));
                    }
                    break;
                case "capital_refund":
                    isBalanceUpdate = false;
                    toast.info($t("socket.refund", { amount, mnemonic, name }));
                    break;
                case "investments_release":
                    toast.info($t("socket.release", { amount, mnemonic, name }));
                    break;
                case "Transfer to the exchange":
                    toast.info($t("socket.toExchange", { amount, mnemonic }));
                    break;
                case "Transfer from the exchange":
                    toast.info($t("socket.fromExchange", { amount, mnemonic }));
                    break;
                case "referrals":
                    toast.info($t("socket.referrals", { amount, mnemonic }));
                    break;
                case "Payment for open sale tokens":
                    toast.info($t("socket.decreased", { amount, mnemonic }));
                    break;
                case "Transfer of open sale tokens":
                    toast.info($t("socket.transferOpenSale", { amount: amount, name: transaction?.auToken?.nameEng }));
                    store.commit("capitals/setUpdateInfoFlag", store.getters["capitals/updateInfoFlag"] + 1);
                    break;
                default:
                    toast.info($t("socket.balanceChange", { amount, mnemonic }));
                    break;
            }
        }
    }
    return isBalanceUpdate;
};
const SocketPlugin = {
    install(app) {
        app.config.globalProperties.$socket = socket;
        // Добавляем методы для работы с сокетом
        app.provide("socket", socket);
    }
};
export default SocketPlugin;
